import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attd-val"
export default class extends Controller {
  static values = { capacity: Number }

  static targets = ["modal"]

  connect() {
    const input = this.element.querySelector('#spaces_finder_capacity')
    const dummyInput = this.element.querySelector('.attendees__dummy')
    const incr = this.element.querySelector('.attendees__incr')
    const decr = this.element.querySelector('.attendees__decr')
    let i =  this.capacityValue;

    input.addEventListener('change', () => {
      i = input.value;
      dummyInput.value = input.value;
    })

    dummyInput.addEventListener('change', () => {
      i = dummyInput.value;
      input.value = dummyInput.value;
    })

    incr.addEventListener('click', () => {
      if(i < 150){
        i++;
        input.value = i;
        dummyInput.value = i;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    })

    decr.addEventListener('click', () => {
      if(i >= 2){
        i--;
        input.value = i;
        dummyInput.value = i;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    })
  }
  open() {
    this.modalTarget.classList.add('open');
  }
  close() {
    this.modalTarget.classList.remove('open');
  }
}
